import HttpClient from '../../HttpClient/NewApi';
import {concatAll, map, toArray} from "rxjs/operators";
import {of} from "rxjs";

export default {
    getBySupplier(supplierId) {
        return HttpClient
            .get(`/api/v1/sales-orders/of-supplier/${supplierId}`)
            .pipe(
                concatAll(response => of(response)),
                map(salesOrder => new SalesOrder(
                    salesOrder.id,
                    salesOrder.price,
                    salesOrder.volume,
                    salesOrder.address,
                    salesOrder.status,
                    salesOrder.quality,
                    salesOrder.createdAt,
                    salesOrder.overdueAt,
                    salesOrder.cultureId,
                )),
                toArray(),
            )
    },
}

const NEW = 'new';
const WAIT_IN_PROGRESS = 'waitInProgress';
const IN_PROGRESS = 'inProgress';
const COMPLETED = 'completed';
const CANCELLED = 'canceled';

class SalesOrder
{
    constructor(
        id,
        price,
        volume,
        address,
        status,
        quality,
        createdAt,
        overdueAt,
        cultureId
    ) {
        this.id = id;
        this.price = price;
        this.volume = volume;
        this.address = address;
        this.status = status;
        this.quality = quality;
        this.createdAt = createdAt;
        this.overdueAt = overdueAt;
        this.cultureId = cultureId;
    }

    canBeCancelled()
    {
        return this.isActive();
    }

    isActive()
    {
        return [
            NEW,
            IN_PROGRESS,
            WAIT_IN_PROGRESS
        ].includes(this.status)
    }

    getReadableStatus()
    {
        const statuses = {
            new : "Новая",
            waitInProgress: 'Ожидает подтверждения',
            inProgress: 'В работе',
            completed: 'завершена',
            canceled: 'отменена'
        }

        return statuses[this.status]
    }

    isNew()
    {
        return this.status === NEW;
    }

    isWaitingInProgress()
    {
        return this.status === WAIT_IN_PROGRESS;
    }

    isInProgress()
    {
        return this.status === IN_PROGRESS;
    }

    isCompleted()
    {
        return this.status === COMPLETED;
    }

    isCancelled()
    {
        return this.status === CANCELLED;
    }
}


// WEBPACK FOOTER //
// ./apiClient/SalesOrder/GetListBySupplier/index.js